import Layout from "./MenuLayout";
import LeftMenu from "./MenuLayoutLeft";
import RightMenu from "./MenuLayoutRight";

Layout.Right = RightMenu;
Layout.Left = LeftMenu;

export default Layout;
